import { getTypeLabel } from "@typings/entities/samples/enums";
import type { Visit } from "@typings/entities/visit";
import { VisitTypeHelper } from "@typings/entities/visit/enums";
import { formatDate } from "@utils/formatters";

export interface VisitItemListWithLabels
  extends Omit<Visit, "visitType" | "sampleTypes"> {
  visitType: string;
  sampleTypes?: string[];
}

export function prepareVisitsTable(visits: Visit[]): VisitItemListWithLabels[] {
  return visits.map((visit) => ({
    ...visit,
    date: formatDate(visit.date || null),
    visitType: visit.visitType
      ? VisitTypeHelper.getLabel(visit.visitType)
      : "-",
  }));
}

export function prepareVisitDetail(visit: Visit): VisitItemListWithLabels {
  return {
    ...visit,
    date: formatDate(visit.date || null),
    visitType: visit.visitType
      ? VisitTypeHelper.getLabel(visit.visitType)
      : "-",
    sampleTypes: visit.sampleTypes ? visit.sampleTypes.map(getTypeLabel) : [],
  };
}
